module.exports = {
      id: "icon-booking-treatment-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-booking-treatment",
      toString: function () {
        return this.url;
      }
    }